<template>
  <div class="staff-trial">
    <div class="header">
      <el-form
        :inline="true"
        :model="tableParams"
        size="mini"
        class="demo-form-inline"
      >
        <el-form-item label="">
          <el-select
            v-model="tableParams.isAudit"
            :placeholder="
              $lange == 'en' ? 'Please Select Status' : '请选择状态'
            "
            clearable
          >
            <el-option
              :label="$lange == 'en' ? 'Untreated' : '未审批'"
              value="0"
            ></el-option>
            <el-option
              :label="$lange == 'en' ? 'Approved' : '已审批'"
              value="1"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input
            :placeholder="$lange == 'en' ? 'JobId' : 'JobId'"
            size="mini"
            v-model="tableParams.jobId"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input
            :placeholder="$lange == 'en' ? 'Customer Name' : '客户'"
            size="mini"
            v-model="tableParams.customerName"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>

        <el-form-item label="">
          <el-select
            v-model="tableParams.managerId"
            size="mini"
            :placeholder="this.$lange == 'en' ? 'Responsible' : '处理人'"
            clearable
          >
            <el-option
              v-for="(itmem, index) in user"
              :label="itmem.name"
              :value="itmem.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-button type="primary" size="mini" @click="doSearch">{{
          $lange == "en" ? "Search" : "搜索"
        }}</el-button>
      </el-form>
    </div>
    <div class="content">
      <cc-table
        :config="tableConfig"
        :params="tableParams2"
        :refesh-params="refeshTable"
      >
      </cc-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "StaffTrial",
  data() {
    return {
      user: [],
      form: {
        user: "",
        region: "",
      },
      tableConfig: {
        api: "admin/fsb/personnel/review/query",
        showPager: true,
        columns: [
          {
            prop: "id:",
            lable: "任务ID",
            type: "text",
            render: (row) => {
              return row.id;
            },
              minWidth: 160,
          },
          {
            prop: "jobId",
            lable: "JobId",
            type: "text",
              minWidth: 100,
          },
          {
            prop: "customerName",
            lable: "客户",
            type: "text",
              minWidth: 100,
          },
          {
            prop: "type",
            lable: "类型",
            render: (row) => {
              let arr = ["安装服务", "售后服务", "售后服务"];
              return arr[row.type];
            },
              minWidth: 100,
          },
          {
            prop: "startTime",
            lable: "项目开始时间",
            type: "text",
              minWidth: 160,
          },
          {
            prop: "peopleNum",
            lable: "人数",
            type: "text",
          },
          {
            prop: "workHour",
            lable: "工时",
            type: "text",
          },
          {
            prop: "createTime",
            lable: "创建时间",
            type: "text",
              minWidth: 160,
          },
          {
            prop: "status",
            lable: "状态",
            render: (row) => {
              return ["未审批", "已审批"][row.status];
            },
          },
          {
            prop: "handlerName",
            lable: "处理人",
              minWidth: 110,
          },
        ],
        buttonsLabel: "审批",
        buttons: [
          {
            name: "详情",
            check: (row) => {
              return row.status === 1;
            },
            click: (row) => {
              this.$router.push({
                path: "/admin/staff/description",
                query: {
                  id: row.id,
                },
              });
            },
          },
          {
            name: "审批",
            check: (row) => {
              return row.status !== 1;
            },
            click: (row) => {
              this.$router.push({
                path: "/admin/staff/description",
                query: {
                  id: row.id,
                  isTrial: true,
                },
              });
            },
          },
        ],
      },
      tableParams: {
        isAudit: "",
      },
      tableParams2: {
        isAudit: "",
      },
      refeshTable: -1,
    };
  },
  methods: {
    doSearch() {
      this.tableParams2 = { ...this.tableParams };
    },
    delResponse(item) {
      console.log(item);
    },
    checkLanguage() {
      if (this.$lange == "en") {
        this.tableConfig = {
          api: "admin/fsb/personnel/review/query",
          showPager: true,
          columns: [
            {
              prop: "id",
              lable: "Task ID",
              type: "text",
              render: (row) => {
                return row.id;
              },
            },
            {
              prop: "customerName",
              lable: "Customer",
              type: "text",
            },
            {
              prop: "type",
              lable: "Type",
              render: (row) => {
                let arr = [
                  "Installing",
                  "After-sale service",
                  "After-sale service",
                ];
                return arr[row.type];
              },
            },
            {
              prop: "startTime",
              lable: "Project start time",
              render: (row) => {
                return moment(row.startTime).format("YYYY-MM-DD");
              },
            },
            {
              prop: "peopleNum",
              lable: "Number",
              type: "text",
            },
            {
              prop: "workHour",
              lable: "WorkHour",
              type: "text",
            },
            {
              lable: "Create time",
              render: (row) => {
                return moment(row.createTime).format("YYYY-MM-DD");
              },
            },
            {
              prop: "status",
              lable: "Status",
              render: (row) => {
                return ["Untreated", "Approved"][row.status];
              },
            },
          ],
          buttonsLabel: "Approve",
          buttons: [
            {
              name: "Description",
              check: (row) => {
                return row.status === 1;
              },
              click: (row) => {
                this.$router.push({
                  path: "/admin/staff/description",
                  query: {
                    id: row.id,
                  },
                });
              },
            },
            {
              name: "Approve",
              check: (row) => {
                return row.status === 0;
              },
              click: (row) => {
                this.$router.push({
                  path: "/admin/staff/description",
                  query: {
                    id: row.id,
                    isTrial: true,
                  },
                });
              },
            },
          ],
        };
      }
    },
  },
  mounted() {
    this.checkLanguage();
    this.ccRequest
      .do("admin/fsb/user/query", { pageSize: 2000 }, "GET")
      .then((res) => {
        this.user = res;
      });
  },
};
</script>

<style scoped lang="scss">
.staff-trial {
  .header {
    background: #ffffff;
    padding: 20px;
    padding-bottom: 0;
  }
  .content {
    padding: 20px;
    margin-top: 20px;
    background: #ffffff;
  }
}
</style>
